import produce from "immer";
import { isEqual } from "lodash";
import { useCallback, useMemo, useState } from "react";
import { Option } from "space-monad";

const setTx = produce((txList, { index, item }) => {
  txList[index] = item;
});

export function useList<T>(defaultValue: T, defaultTransactions?: T[]) {
  const [transactions, innerSetTransactions] = useState<T[]>(
    Option(defaultTransactions)
      .filter((x) => x.length > 0)
      .getOrElse([defaultValue])
  );

  const setTransaction = useCallback(
    (index: number, item: T) =>
      innerSetTransactions(setTx(transactions, { item, index })),
    [transactions]
  );

  const addTransaction = useCallback(
    () => innerSetTransactions([...transactions, defaultValue]),
    [transactions]
  );
  const removeTransaction = useCallback(
    (index: number) =>
      innerSetTransactions(transactions.filter((_, i) => i !== index)),
    [transactions]
  );

  const canAddMore = useMemo(
    () => !transactions.find((f) => isEqual(f, defaultValue)),
    [transactions]
  );

  return [
    transactions,
    setTransaction,
    addTransaction,
    removeTransaction,
    canAddMore,
  ] as const;
}
